export default {"src":"/_next/static/media/user.c84677e2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};